import * as Yup from 'yup';

// Define supported file formats

export const careersFormValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .required('First Name is required')
    .min(2, 'First Name must be at least 2 characters')
    .max(50, 'First Name must be less than 50 characters'),
  
  lastName: Yup.string()
    .trim()
    .required('Last Name is required')
    .min(2, 'Last Name must be at least 2 characters')
    .max(50, 'Last Name must be less than 50 characters'),
  
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  
  phone: Yup.string()
    .required('Phone Number is required')
    .min(8, 'Phone number is too short'),
  
  jobTitle: Yup.string()
    .trim()
    .required('Job Title / Role is required')
    .min(2, 'Job Title must be at least 2 characters')
    .max(100, 'Job Title must be less than 100 characters'),
  
  experience: Yup.string()
    .required('Years of Experience is required'),
  
  resume: Yup.string()
    .required('Resume is required'),
  
  
  workRights: Yup.string()
    .required('Please indicate your work rights in Australia')
    .oneOf(['yes', 'no'], 'Please select an option')
});